import { render, staticRenderFns } from "./NewsCardTemplate.vue?vue&type=template&id=3f41922e"
import script from "./NewsCardTemplate.vue?vue&type=script&lang=js"
export * from "./NewsCardTemplate.vue?vue&type=script&lang=js"
import style0 from "./NewsCardTemplate.vue?vue&type=style&index=0&id=3f41922e&prod&lang=stylus&module=attr"




function injectStyles (context) {
  
  this["attr"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HeaderTemplate: require('/var/www/malayan/web/components/global/templates/HeaderTemplate.vue').default})
